import * as Material from "@mui/material";
import { useTranslation } from "react-i18next";

import "./styles.scss";

import { Button } from "@fragments";

import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { TopicRounded } from "@mui/icons-material";
import SourceRoundedIcon from '@mui/icons-material/SourceRounded';

export default function MaterialsBar({ info, handleChangeMaterial }) {
    const { t } = useTranslation("community");

    function handleOpenMaterial(data) {
        window.navigate(info.slug + '/materials/' + data.id)
    }

    function MaterialBox({ data }) {
        if (!data) return null

        return (
            <div
                className="material"
                onClick={() => handleOpenMaterial(data)}
            >
                <div className="banner-box">
                    <div className="icon-box bsf-9">
                        <SourceRoundedIcon className="csf-2"/>
                    </div>

                    {data?.banner
                        ? <img src={data.banner} className="banner" />
                        : <div className="banner" />}

                </div>

                <img src={data?.banner} className="banner-effect-on-hover" />
            </div>
        )
    }

    if (!info.isAdmin() && !info?.materials) {
        return null
    }

    return (
        <div className="materials-bar mb-2 screen-padding">
            <div className="header pt-1  py-1 csf-2">
                <TopicRounded className="section-icon" />

                <h3 className="bold">{t("materialsBar.title")}</h3>

                {info.isAdmin() && (
                    <Button
                        tooltip={t("materialsBar.addMaterial")}
                        onClick={() => handleChangeMaterial({
                            community: info.id
                        })}
                        icon={<AddRoundedIcon />}
                        color="overlay"
                    />
                )}
            </div>

            <div className="materials-columns mt-1 mb-1">
                {
                    info?.materials?.map((m, k) => <MaterialBox data={m} key={k} />)
                }
            </div>

        </div>
    );
}